<template>
  <div ref="imgContent" style="width: 100%;position: relative">
    <vue-drag-resize :h="46"
                     :isResizable="false"
                     :key="item.id"
                     :parentH="imgHeight"
                     :parentW="imgWidth"
                     :isDraggable="typeof(deviceListWidthId[item.deviceId])!=='undefined'?(deviceListWidthId[item.deviceId].typeEngName === 'PM_WLD' ? false : edit):false"
                     :w="34"
                     :x="item.xoffset.split(',').length > 1 ?  Number.parseFloat(item.xoffset.split(',')[1])*imgWidth/item.xoffset.split(',')[0]-17 : item.xoffset*imgWidth/100-17"
                     :y="item.yoffset.split(',').length > 1 ? Number.parseFloat(item.yoffset.split(',')[1])*imgHeight/item.yoffset.split(',')[0]-46 : item.yoffset*imgHeight/100-46"
                     @dragstop="(point) => {return stopDrag(point,item)}"
                     style="z-index: 99;cursor:pointer;"
                     v-for="item in boundDeviceList">
      <div @dblclick="openDialog(item)"
           style="position: absolute;width: 34px;height: 46px;">
      </div>
      <img :height="46" :src="$ftpUrl + item.icon" :title="item.deviceName"
           :width="34" style="float: left;z-index: 999">
      <div class="name">
        <div class="deviceName">
          <i @touchstart="delDevice(item)" @click="delDevice(item)"
             class="el-icon-close close-btn float-right pointer"
             style="margin-right: -18px;margin-top: 2px;"></i>
          {{ item.deviceName }}
        </div>
      </div>
    </vue-drag-resize>
    <!--      漏水线-->
    <canvas :height="initHeight" :width="initWidth"
            @contextmenu.prevent id="slackLineContainer"
            ref="slackLineContainer" style="position: absolute;top: 0;z-index: 10"></canvas>
    <!--      背景图-->
    <img
      :src="judgeImage()?$ftpUrl + spaceInfo.bgImage:require('@/assets/images/no-bg.png')"
      @load="resizeDrawSlackLineContainer"
      @error="resizeDrawSlackLineContainer"
      alt=""
      class="bg-img"
      height="100%"
      ref="spaceBackgroundImage"
      width="100%"
    >

    <!--    弹出窗-->
    <function-dialog-component
      :dialog-title="title"
      :dialogVisible.sync="dialogVisible"
      :width="dialogWidth"
      @dialogClose="(data) => this.dialogVisible = data"
      center>
      <div slot="content" style="padding: 10px 30px 20px 30px;">
        <point-edit :pointList="pointList" @setCheckPoint="setCheckPoint" v-if="operate === 'point'"></point-edit>
      </div>
      <div class="dialog-footer" slot="footer" style="text-align: center; margin-top: 5px; margin-bottom: 15px;">
        <el-button @touchstart="() => {this.dialogVisible = false;}" @click="() => {this.dialogVisible = false;}" size="mini">关 闭</el-button>
        <el-button @touchstart="preservation" @click="preservation" size="mini" type="primary">保 存</el-button>
      </div>
    </function-dialog-component>
  </div>
</template>

<script>
import {getSpaceInfoById} from "@/network/space-info";
import {getDeviceListBySpaceIdAndCategoryTagId} from "@/network/device-info";
import {getSpaceMap, update} from "@/network/space-map";
import VueDragResize from 'vue-drag-resize';
import FunctionDialogComponent from "@/components/FunctionDialogComponent";
import PointEdit from "@/views/basic_operations/device_management/electronic_map/PointEdit";
import {listByDeviceId, updatePointList} from "@/network/device-measuring-point";

export default {
  name: "EditIndoorSettingDevice",
  components: {VueDragResize, FunctionDialogComponent, PointEdit},
  props: {
    spaceId: {
      type: String,
      default: () => '0'
    },
  },
  data() {
    return {
      spaceInfo: {},
      spaceMap: [],
      deviceList: [],
      deviceListWidthId: {},
      boundDeviceList: [], //已绑的设备
      unBoundDeviceList: [], //未绑的设备
      slackLineDeviceList: [], //已绑的漏水设备
      edit: true,
      imgWidth: 0,
      imgHeight: 0,
      initWidth: 0,
      initHeight: 0,
      flag: false, //是否画线
      x: [],
      y: [],
      title: '测点编辑',
      dialogVisible: false,
      dialogWidth: '45vw',
      operate: 'point',
      pointList: [],
      checkPointIds: [],
      xratio: 0,
      yratio: 0
    }
  },
  created() {
    setTimeout(() => {
      this.getDeviceList(this.spaceId)
    }, 100)
  },
  mounted() {
    this.getSpaceInfo(this.spaceId)
    window.addEventListener("resize", () => {
      console.log("进入了分辨率改变事件")
      this.resizeDrawSlackLineContainer()
    });
  },
  watch: {
    spaceId(newVal) {
      this.spaceMap = []
      this.deviceList = []
      this.getSpaceInfo(newVal)
    },
  },
  methods: {
    // 重置漏水线大小
    resizeDrawSlackLineContainer() {
      this.imgHeight = this.$refs.spaceBackgroundImage.height
      this.imgWidth = this.$refs.spaceBackgroundImage.width
      this.initHeight = this.$refs.spaceBackgroundImage.height
      this.initWidth = this.$refs.spaceBackgroundImage.width
      // }
      if (!this.$refs.slackLineContainer || !this.$refs.spaceBackgroundImage) {
        return
      }
      setTimeout(() => {
        if (this.$refs.slackLineContainer && this.$refs.spaceBackgroundImage) {
          this.$refs.slackLineContainer.style.height = this.$refs.spaceBackgroundImage.height + 'px'
          this.$refs.slackLineContainer.style.width = this.$refs.spaceBackgroundImage.width + 'px'
        }
      }, 100)
    },
    getSpaceInfo(id) {
      if (id === '') {
        return
      }
      getSpaceInfoById(id).then(res => {
        if (res.data) {
          this.spaceInfo = res.data
          this.getDeviceList(this.spaceInfo.id)
        }
      })
    },
    //获取所有设备
    getDeviceList(spaceId) {
      getDeviceListBySpaceIdAndCategoryTagId(spaceId).then(res => {
        if (res.data) {
          this.deviceList = []
          this.deviceList = res.data
          this.deviceListWidthId = {}
          this.deviceList.forEach(device => {
            this.deviceListWidthId[device.id] = device
          })
          this.getSpaceMap(this.spaceInfo.id)
        }
      })
    },
    getSpaceMap(spaceId) {
      if (spaceId === '' || spaceId === null || spaceId === undefined) {
        return
      }
      getSpaceMap(spaceId).then(res => {
        if (res.data) {
          this.spaceMap = res.data
          this.getFilterDevice()
        }
      })
    },
    //筛选已绑的设备和未绑的设备
    getFilterDevice() {
      this.unBoundDeviceList = this.spaceMap.filter(item => !item.xoffset && !item.yoffset && this.deviceListWidthId[item.deviceId])
      this.boundDeviceList = this.spaceMap.filter(item => (item.xoffset || item.yoffset) && this.deviceListWidthId[item.deviceId])
      this.slackLineDeviceList = this.spaceMap.filter(item => (item.xoffset || item.yoffset) && this.deviceListWidthId[item.deviceId] !== null
        && typeof (this.deviceListWidthId[item.deviceId]) !== 'undefined' && this.deviceListWidthId[item.deviceId].typeEngName === 'PM_WLD')
      this.$emit("getUnboundDeviceList", this.unBoundDeviceList)
      this.initSlackLine()
    },
    // 初始化漏水线
    initSlackLine() {
      if (!this.$refs.slackLineContainer) {
        return
      }
      const canvasObj = this.$refs.slackLineContainer.getContext('2d')
      canvasObj.lineWidth = 5
      // 清空画布
      canvasObj.clearRect(0, 0, this.$refs.slackLineContainer.width, this.$refs.slackLineContainer.height);
      // 开始画线
      this.slackLineDeviceList.forEach(map => {
        let deviceInfo = this.deviceListWidthId[map.deviceId];
        canvasObj.beginPath()
        canvasObj.strokeStyle = deviceInfo.status === 0 ? 'green' : 'rgba(191, 40, 49, 0.85)'
        if (map.yoffset !== null && map.yoffset.length > 0 && map.xoffset !== null && map.xoffset.length > 0) {
          let yArray = map.yoffset.split(',');
          let xArray = map.xoffset.split(',');

          // 处理一下比例的问题
          this.xratio = this.initWidth / xArray[0]
          this.yratio = this.initHeight / yArray[0]
          xArray.forEach((item, index) => {
            if (index === 0) {
              // this.initWidth = parseFloat(item)
              // this.initHeight = parseFloat(yArray[index])
            } else if (index === 1) {
              canvasObj.moveTo(parseFloat(item * this.xratio), parseFloat(yArray[index] * this.yratio))
            } else if (index !== 1 && index !== 0) {
              canvasObj.lineTo(parseFloat(item * this.xratio), parseFloat(yArray[index] * this.yratio))
            }
          })
        }
        canvasObj.stroke();
      })
      this.isDragging = false;
    },
    // 判断是否有背景图
    judgeImage() {
      let flag = false
      if (typeof (this.spaceInfo) !== 'undefined' && this.spaceInfo
        && typeof (this.spaceInfo.bgImage) !== 'undefined' && this.spaceInfo.bgImage) {
        flag = true
      }
      return flag
    },
    mouseDown(e, item, canvasObj) {
      if (this.flag) {
        console.log("鼠标落下", e, this.x, this.y, e.offsetX, e.offsetY);
        if (e.button === 0) {
          if (this.x.length < 2) {
            canvasObj.moveTo(e.offsetX, e.offsetY);
          } else {
            canvasObj.lineTo(e.offsetX, e.offsetY)
            canvasObj.stroke();
          }
          this.x.push(e.offsetX); // 鼠标落下时的X
          this.y.push(e.offsetY); // 鼠标落下时的Y
        } else if (e.button === 2) {
          this.flag = false
          if (this.x.length > 2) {
            item.xoffset = this.x.toString()
            item.yoffset = this.y.toString()
            this.update(item)
            this.x = []
            this.y = []
          }
        }
      }
    },
    // 画漏水线
    drawSlackLine(item) {
      const slackLineContainer = this.$refs.slackLineContainer;
      slackLineContainer.oncontextmenu = false;
      let canvasObj = slackLineContainer.getContext('2d')
      canvasObj.strokeStyle = 'green';
      canvasObj.lineWidth = 5;
      canvasObj.beginPath();
      this.x.push(this.initWidth)
      this.y.push(this.initHeight)
      slackLineContainer.onmousedown = (e) => this.mouseDown(e, item, canvasObj);
      this.isDragging = false;
    },
    //停止拖拽
    stopDrag(point, item) {
      // 防止频繁执行
      if (this.isDragging) {
        return;
      }
      console.log(123)
      this.isDragging = true;
      const initX = 17 * 100 / this.imgWidth;
      const initY = 46 * 100 / this.imgHeight;
      if (this.deviceListWidthId[item.deviceId].typeEngName === 'PM_WLD') {
        this.drawSlackLine(item)
        this.flag = true
        this.$message.info("请在内景图上左击画漏水线,右击保存漏水线!")
      } else {
        if (point) {
          item.xoffset = point.left > -16 ? ((point.left + 17) * 100 / this.imgWidth).toString() : initX.toString();
          item.yoffset = point.top > -46 ? ((point.top + 46) * 100 / this.imgHeight).toString() : initY.toString();
        } else {
          item.xoffset = initX;
          item.yoffset = initY;
        }
        this.update(item);
      }
    },
    //更新地图信息
    update(item, isDel) {
      update(item).then(res => {
        if (res.code === 0) {
          const device = this.deviceListWidthId[item.deviceId]
          // 判断类型是否为漏水线
          if (device.typeEngName === 'PM_WLD') {
            if (isDel) {
              this.$message.success(device.name + "删除成功!")
            } else {
              this.$message.success(device.name + "添加成功!")
            }
          }
          this.getSpaceInfo(this.spaceId)
        }
      })
    },
    delDevice(item) {
      this.$confirm('是否确认删除' + item.deviceName, {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        callback: action => {
          if (action === 'confirm') {
            item.xoffset = null
            item.yoffset = null
            this.update(item, true)
          }
        }
      })
    },
    openDialog(item) {
      this.dialogVisible = true;
      this.pointList = [];
      listByDeviceId(item.deviceId).then(res => {
        if (res.code === 0) {
          this.pointList = res.data
        }
      })
    },
    //获取勾选的测点id
    setCheckPoint(data) {
      this.checkPointIds = data
    },
    preservation() {
      const result = this.pointList.map(item => {
        item.spaceShow = this.checkPointIds.indexOf(item.id) > -1;
        return item
      })
      updatePointList(result).then(res => {
        if (res.code === 0) {
          this.$message.success("保存成功!")
        } else {
          this.$message.error("保存失败!")
        }
        this.dialogVisible = false;
      })
    },
  },
  destroyed() {
    window.onresize = null;
  }
}
</script>

<style scoped>
.name {
  background-color: rgba(0, 111, 255, 0.5);
  color: #fff;
  font-size: 0.8rem;
  margin-left: 15px;
  line-height: 28px;
  margin-top: 16px;
  white-space: nowrap;
}

.name .deviceName {
  display: inline-block;
  background-color: rgba(0, 111, 255, 0.5);
  padding-right: 22px;
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
}
</style>
